var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentOvo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990.12 324.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a4ea0;stroke-miterlimit:10;stroke-width:25.32px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo OVO 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.1,
    y: 50.63,
    width: 214.58,
    height: 223.62,
    rx: 103.98,
    ry: 103.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.66,
    y: 12.66,
    width: 287.46,
    height: 299.57,
    rx: 138.95,
    ry: 138.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 726.44,
    y: 50.63,
    width: 214.58,
    height: 223.62,
    rx: 103.98,
    ry: 103.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 690,
    y: 12.66,
    width: 287.46,
    height: 299.57,
    rx: 138.95,
    ry: 138.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.14,57.26H355.3a38.82,38.82,0,0,1,11.75,1.06c6.13,1.49,9.27,4.83,12.36,8.59,4.61,5.61,6.59,10.83,9,17.48a112.94,112.94,0,0,1,5.42,20.49l41,144.06a119.93,119.93,0,0,0,7.84,22.9c3,6.44,5.13,11.06,9.64,16.28a58.47,58.47,0,0,0,13.86,11.45c5.06,3.2,8.86,5.61,14.47,6.63,3,.55,3.05.9,12.66.83,10.56-.08,10.92-.33,15.67-.83,4-.43,9.12-1,14.47-3.62,1.93-1,6.11-3.29,13.26-12.05A112.3,112.3,0,0,0,550,270a134.23,134.23,0,0,0,10.85-30.13l44.6-158.53a28.31,28.31,0,0,1,6.63-15.07,26.22,26.22,0,0,1,15.45-8.51c4.14-.85,10.69-.6,14.69-.53h26.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M668.73,20.49h-54.1a35.6,35.6,0,0,0-11.75,4.22c-4.78,2.76-7.7,6-11.3,9.95a88.86,88.86,0,0,0-7.69,9.94,123,123,0,0,0-7.68,12.57,125,125,0,0,0-5.05,12l-9,28.78L524.67,229.5c-1.42,5.64-3.59,10-5,13.64-1.25,3.15-.09,1.5-6.25,14.39-1.79,3.73-3,6.33-5.88,8.59a14.51,14.51,0,0,1-5.42,2.71,24.87,24.87,0,0,1-13.26,0,14.6,14.6,0,0,1-5.43-2.71c-2.87-2.26-4.09-4.86-5.88-8.59-6.16-12.89-5-11.24-6.25-14.39-1.45-3.66-3.63-8-5.05-13.64L428.68,98l-9-28.78c-1.83-4.65-3.35-8.77-5.05-12A123.84,123.84,0,0,0,407,44.6a88.68,88.68,0,0,0-7.68-9.94c-3.6-4-6.52-7.19-11.3-9.95a35.58,35.58,0,0,0-11.76-4.22h-54.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentOvo);
export default __webpack_public_path__ + "static/media/payment_ovo.96ab9c491b2b9f22ab2b9899c1889d16.svg";
export { ForwardRef as ReactComponent };